import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchAllSyncConfigs = createAsyncThunk('bulkSync/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/bulk-action/configs`);
    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.message || 'Failed to fetch');
  }
});

export const createSyncConfig = createAsyncThunk('bulkSync/create', async (dto, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/bulk-action/config`, dto);
    await dispatch(fetchAllSyncConfigs());
    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.message || 'Failed to create');
  }
});

export const updateSyncConfig = createAsyncThunk('bulkSync/update', async ({ id, dto }, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.put(`${API_URL}/bulk-action/config/${id}`, dto);
    await dispatch(fetchAllSyncConfigs());
    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.message || 'Failed to update');
  }
});

export const deleteSyncConfig = createAsyncThunk('bulkSync/delete', async (id, { dispatch, rejectWithValue }) => {
  try {
    await axios.delete(`${API_URL}/bulk-action/config/${id}`);
    await dispatch(fetchAllSyncConfigs());
    return id;
  } catch (err) {
    return rejectWithValue(err.response?.data?.message || 'Failed to delete');
  }
});

export const runMasterSync = createAsyncThunk('bulkSync/runMaster', async (id, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/bulk-action/config/${id}/run`);
    return { id, message: response.data.message };
  } catch (err) {
    return rejectWithValue(err.response?.data?.message || 'Failed to run sync');
  }
});

const bulkSyncSlice = createSlice({
  name: 'bulkSync',
  initialState: { configs: [], status: 'idle', syncingIds: {}, error: null },
  reducers: { clearSyncError: (state) => { state.error = null; } },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllSyncConfigs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.configs = action.payload;
      })
      .addCase(runMasterSync.pending, (state, action) => {
        state.syncingIds[action.meta.arg] = 'running';
      })
      .addCase(runMasterSync.fulfilled, (state, action) => {
        delete state.syncingIds[action.payload.id];
      })
      .addCase(runMasterSync.rejected, (state, action) => {
        delete state.syncingIds[action.meta.arg];
      })
      .addMatcher(
        (action) => action.type.endsWith('/pending') && !action.type.includes('runMaster'),
        (state) => { state.status = 'loading'; state.error = null; }
      )
      .addMatcher(
        (action) => action.type.endsWith('/rejected') && !action.type.includes('runMaster'),
        (state, action) => { state.status = 'failed'; state.error = action.payload; }
      );
  },
});

export const { clearSyncError } = bulkSyncSlice.actions;
export default bulkSyncSlice.reducer;